import React from 'react';
import styles from './Checkbox.module.scss';

function Checkbox({
  label,
  isChecked,
  name,
  className = '',
  id = '',
  refElement = null,
  required = false,
  style = {},
  onClick = () => {},
  onChange = () => {},
  onBlur = () => {},
}) {
  return (
    <div style={style} className={`${styles.checkboxContainer} ${className ? className : ''}`}>
      <input
        type="checkbox"
        id={id}
        name={name}
        onClick={onClick}
        onChange={onChange}
        onBlur={onBlur}
        ref={refElement}
        defaultChecked={isChecked}
        className={styles.checkbox}
      />
      <label htmlFor={id} className={`${styles.label} ${required ? 'required' : ''}`} style={{ gridColumn: 2 }}>{label}</label>
    </div>
  );
}

export default Checkbox;
